import {
    ListenerNotify,
    Notification,
    Notifications,
    NotificationType
} from "../models/interfaces/notification.interface";
import {AxiosError} from "axios";
import {NotificationConfig} from "../models/interfaces/notification-config.interface";

class NotificationService {
    private listeners: ListenerNotify[] = [];
    private notifications: Notification[] = [];
    private nextId: number = 1;
    private isProcessing: boolean = false;

    addListener(listener: ListenerNotify): void {
        this.listeners.push(listener);
    }

    removeListener(listener: ListenerNotify): void {
        this.listeners = this.listeners.filter((l: ListenerNotify): boolean => l !== listener);
    }

    notify(title: string, message: string, type: NotificationType, duration: number = 3000, config?: NotificationConfig): void {
        const notification: Notification = {
            id: this.nextId++,
            title,
            message,
            type,
            duration
        };

        if (config?.waitForPrevious) {
            this.queueNotification(notification);
        } else {
            this.showNotification(notification);
        }
    }

    private async queueNotification(notification: Notification): Promise<void> {
        if (this.isProcessing) {
            await new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (!this.isProcessing) {
                        clearInterval(interval);
                        resolve(true);
                    }
                }, 50);
            });
        }
        this.showNotification(notification);
    }

    private showNotification(notification: Notification): void {
        this.isProcessing = true;

        this.notifications.push(notification);
        this.listeners.forEach((listener: ListenerNotify) => listener(this.notifications));

        setTimeout(() => {
            this.remove(notification);
            this.isProcessing = false;
        }, notification.duration);
    }


    remove(notification: Notification): void {
        this.notifications = this.notifications.filter((n) => n.id !== notification.id);
        this.listeners.forEach((listener) => listener(this.notifications));
    }

    success(message: string, title: string = "Sukces", config?: NotificationConfig): void {
        this.notify(title, message, Notifications.SUCCESS, config?.duration,config);
    }

    error(customMessage: string, err?: unknown, title: string = "Błąd", config?: NotificationConfig): void {
        let errorMessage: string = customMessage;

        if (err instanceof AxiosError) {
            const hasErrorMessage: boolean = typeof err.response?.data === "string" && err.response.data !== "";
            errorMessage = hasErrorMessage ? err?.response?.data as string : customMessage
        } else if (err instanceof Error) {
            errorMessage = err.message || customMessage;
        } else if (typeof err === "string") {
            errorMessage = err;
        }

        this.notify(title, errorMessage, Notifications.ERROR, config?.duration,config);
    }

    warning(message: string, title: string = "Ostrzeżenie", config?: NotificationConfig): void {
        this.notify(title, message, Notifications.WARNING, config?.duration,config);
    }

    info(message: string, title: string = "Informacja", config?: NotificationConfig): void {
        this.notify(title, message, Notifications.INFO, config?.duration,config);
    }
}

export default new NotificationService();
